import { useIsMutating } from '@tanstack/react-query';
import React, { useEffect, useState } from 'react';

import LoadingSvg from '@/components/common/LoadingSvg';
import { Dialog } from '@/components/shopping_bag/Dialog';
import { useAuthenticated } from '@/components/shopping_bag/hooks/useAuthenticated';
import { Button } from '@/components/ui/button';
import { TmCreditCardType, TmCreditCard, TmAddress } from '@/tscapi/model/account';

import { useAddress } from '../Context/AddressContext';
import { useAccount } from '../hooks/useAccount';
import { useRemoveCreditCard } from '../hooks/useCreditcard';
import { getLogoByCreditCardTypeNew, cardTypeName } from '../utils/payment.utils';

import { CardTypeSelector } from './CardTypeSelector';
import { DisplayAddressCard } from './DisplayAddressCard';
import { EditAddress } from './EditAddress';

export const ManageBilling = () => {
    const {
        accordionStates,
        setAccordionStates,
        handleAccordionStateChange,
        setShowNotification,
        setShowWarning,
        mode,
        mode2,
        setMode,
        setMode2,
        updateAccordionAtIndex,
    } = useAddress();
    const isMutating = useIsMutating();
    const isAuthenticated = useAuthenticated();
    const { data, isFetching, error } = useAccount(isAuthenticated);
    const mutation = useRemoveCreditCard();
    const [selectedAddressId, setSelectedAddressId] = useState(null);
    const [selectedAddressType, setSelectedAddressType] = useState('billing');
    const [selectedAddress, setSelectedAddress] = useState<TmAddress>(null);

    const { BillingAddress: card } = data;

    // Custom sorting function
    function customSort(a, b) {
        if (a.IsDefault && !b.IsDefault) {
            return -1; // `a` comes before `b`
        }
        if (!a.IsDefault && b.IsDefault) {
            return 1; // `b` comes before `a`
        }
        return 0; // No change in ordering
    }

    return (
        <>
            {mode2 == 'view' ? (
                <>
                    {/* view existing addresses */}
                    {data && (
                        <div className="grid grid-cols-1 gap-5 md2:grid-cols-2">
                            {data.BillingAddress && (
                                <div>
                                    <DisplayAddressCard addressData={data.BillingAddress} type={selectedAddressType} />

                                    <div className="mt-2.5 grid grid-cols-1 gap-2">
                                        <Button
                                            type="button"
                                            aria-label={'Edit'}
                                            // className="manage__buttons Edit"
                                            tabIndex={0}
                                            size="lg"
                                            variant="outline"
                                            onClick={() => {
                                                updateAccordionAtIndex(0, true);
                                                updateAccordionAtIndex(1, true);
                                                updateAccordionAtIndex(2, false);
                                                setMode('view');
                                                setMode2('edit');
                                                setSelectedAddressId(card.Id);
                                                setSelectedAddressType('billing');
                                                setSelectedAddress(data.BillingAddress);
                                            }}
                                        >
                                            Edit
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </>
            ) : (
                <>
                    {/* edit a specific address */}
                    <EditAddress
                        selectedAddress={selectedAddress}
                        selectedAddressId={selectedAddressId}
                        selectedAddressType={selectedAddressType}
                    />
                </>
            )}

            {mutation.isLoading || isMutating ? (
                <div className="blockPageWrap" style={{ display: 'block' }}>
                    <div className="blockPageOverlay"></div>
                    <div className="blockMsg">
                        <LoadingSvg />
                    </div>
                </div>
            ) : null}
        </>
    );
};
